(ns com.theplantscape.plant-web.store.core
  (:require [com.theplantscape.plant-web.api.plants :refer [search-plants]]))

(def remote true)
(defn fetch-search-results [search cb]
  (if remote
    (search-plants search cb)
    (search-plants search cb)))
